import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-ng-select',
  template: `
    <ng-select
      [items]="to.options"
      [bindLabel]="to.bindLabel || 'label'"
      [bindValue]="to.bindValue || 'value'"
      [multiple]="to.multiple || false"
      [selectableGroup]="to.selectableGroup || false"
      [closeOnSelect]="to.closeOnSelect ?? true"
      [searchable]="to.searchable ?? true"
      [clearable]="to.clearable ?? true"
      [placeholder]="to.placeholder"
      [readonly]="to.readonly"
      [formControl]="formControl"
      [formlyAttributes]="field"
      class="source-dropdown cust-name-select full-width-ng-select"
    >
      <ng-template ng-option-tmp let-item="item" let-item$="item$.selected" let-index="index">
        {{ to.translateOptions === false ? item[to.bindLabel || 'label'] : (item[to.bindLabel || 'label'] | translate) }}
      </ng-template>
    </ng-select>
  `,styleUrls: ['./formly-ng-select.component.scss']
})
export class FormlyNgSelectComponent extends FieldType {}
